import { render, staticRenderFns } from "./HomeModules.vue?vue&type=template&id=7534d3d8"
import script from "./HomeModules.vue?vue&type=script&lang=js"
export * from "./HomeModules.vue?vue&type=script&lang=js"
import style0 from "./HomeModules.vue?vue&type=style&index=0&id=7534d3d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports